import {FC} from 'react'
import {KTSVG} from '../../../../../../_metronic/helpers'
import {AuthenticateUser} from '../../../../../Utils/_helpers/RoleAndPermission'
import useResponsive from '../../../../../hooks/useResponsive'

export type ListActionProps = {
  showModalCreate: () => void
  showModalCreateContact: () => void
}

const ListAction: FC<ListActionProps> = ({showModalCreate, showModalCreateContact}) => {
  const {isMobile} = useResponsive()
  return (
    <div className={`card-toolbar mt-0 ${isMobile ? 'w-100' : ''}`}>
      {AuthenticateUser('upload-contacts') && (
        <button
          type='button'
          className={`btn btn-primary ${isMobile ? 'flex-fill' : 'ms-5'}`}
          onClick={() => showModalCreate()}
        >
          <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-3' />
          Create
        </button>
      )}
    </div>
  )
}

export default ListAction
